module.exports = __webpack_public_path__ + "img/agriculture/default_cover.f17329ac.png";